/*
 *
 * WidgetChartEnps actions
 *
 */

import {
  GET_DATA_ENPS_WATCHER,
  GET_DATA_ENPS_SUCCESS,
  GET_DATA_ENPS_FAILED,
} from "./constants"

export function getDataEnpsWatcher(payload) {
  return {
    type: GET_DATA_ENPS_WATCHER,
    payload,
  }
}

export function getDataEnpsSuccess(payload) {
  return {
    type: GET_DATA_ENPS_SUCCESS,
    payload,
  }
}

export function getDataEnpsFailed() {
  return { type: GET_DATA_ENPS_FAILED }
}
